import mock from 'src/utils/mock';

mock.onGet('/publisher/catalogue/catalogueid').reply(200, {
  catalogueId: 'd12e028c-9f24-4eec-8328-45ad89e8dfa0',
  catalogueInfo: {
    catalogueName: 'ESE - General Studies and Engineering Aptitude-Changed',
    description:
      "This course is primarily aimed at Indian Engineering Services 2020 and 2021 aspirants and covers General Studies and Engineering Aptitude for IES prelims which includes in-depth coverage of Current Issues, Principles of Design, Ethics & Values, Information Communication Technology, Project Management, Energy & Environment, Numerical Ability, and Material science. Current Affairs subject is periodically updated to keep the course relevant and the student's examination and interview ready.",
  },
  category: {
    categoryId: 'b763456e-42e1-4cff-afbc-e88c28e0469a',
    categoryName: 'Engineering',
    subCategory: {
      subCategoryId: '3a510654-15e6-46a8-836b-f8edf44a7e84',
      subCategoryName: 'ESE',
    },
  },
  instructor: true,
  student: true,
  catalogueTheme: {
    imagePath: 'https://d1k3nlqshgkoey.cloudfront.net/Card 2.png',
    colour: '228.225.128.#e4e180',
  },
  publishState: true,
  previewVideos: [
    {
      previewVideoId: '5229ea73-eb7a-4e84-a15c-9f082c469263',
      subjectName: 'Energy & Environment',
      title: null,
      videoUrl:
        'https://d1k3nlqshgkoey.cloudfront.net/preview_noOfVideos/459a6dfd-2613-4db1-94e7-d75b25bdc0a9-SampleVideo_1280x720_1mb.mp4',
      thumbnail:
        'https://d1k3nlqshgkoey.cloudfront.net/preview_noOfVideos/0247a30d-f037-4f88-9f72-f4cefb18a694-d09f54d2-a203-4446-947d-44ac1b361fec (1).png',
    },
    {
      previewVideoId: '349806c1-6e1f-42bc-9a05-c4cdb7b459e8',
      subjectName: 'COMPUTER ORGANISATION',
      title: null,
      videoUrl:
        'https://d1k3nlqshgkoey.cloudfront.net/preview_noOfVideos/0781dd09-837b-4264-8e67-98615ae7fbff-SampleVideo_1280x720_2mb.mp4',
      thumbnail:
        'https://d1k3nlqshgkoey.cloudfront.net/preview_noOfVideos/0247a30d-f037-4f88-9f72-f4cefb18a694-d09f54d2-a203-4446-947d-44ac1b361fec (1).png',
    },
  ],
  instructors: [
    {
      instructorId: 'b88c178b-0093-4d0f-8d4c-e48ce91efeac',
      instructorName: 'Instructor',
      role: 'Professor',
      description: 'Ace employee',
      photo:
        'https://d1k3nlqshgkoey.cloudfront.net/instructors/8841aef9-b21d-4cc8-ada8-104fb563488f-d09f54d2-a203-4446-947d-44ac1b361fec (1).png',
      resume:
        'https://d1k3nlqshgkoey.cloudfront.net/instructors/e94ecf70-58a3-4746-a88b-eeeb518bb66d-1c6f0621-6420-4dcf-80b4-910a8c90e7eb-Termsofuse.pdf',
    },
  ],
  resources: [],
  packageCode: '',
  packageGroupCode: '',
  subscriptions: [
    {
      subscriptionId: 'e013b397-562f-452a-aa69-508f979ff295',
      subscriptionLabel: null,
      subscriptionType: 'FIXED',
      price: 1000.0,
      otsProductList: [],
      subscriptionEndDate: '2021-03-16T02:56:39',
      numberOfMonths: 0,
    },
  ],
  subjects: [
    {
      subjectId: '0f10f310-6b2a-4916-9e28-3e1e07ca73bb',
      subjectName: 'COMPUTER ORGANISATION',
      imagePath: null,
      noOfVideos: 2,
      totalVideoHours: 0,
      noOfUnits: 2,
      noOfTrialVideos: 0,
      comingSoon: false,
      updatesAvailable: false,
      subjectSubscriptionList: [],
      tags: [],
      createdAt: {
        year: 2020,
        monthValue: 6,
        month: 'JUNE',
        dayOfMonth: 9,
        dayOfYear: 161,
        dayOfWeek: 'TUESDAY',
        hour: 19,
        minute: 50,
        second: 3,
        nano: 50000000,
        chronology: {
          calendarType: 'iso8601',
          id: 'ISO',
        },
      },
      updatedAt: {
        year: 2020,
        monthValue: 6,
        month: 'JUNE',
        dayOfMonth: 9,
        dayOfYear: 161,
        dayOfWeek: 'TUESDAY',
        hour: 19,
        minute: 50,
        second: 3,
        nano: 50000000,
        chronology: {
          calendarType: 'iso8601',
          id: 'ISO',
        },
      },
    },
    {
      subjectId: 'd1b30aee-735d-485e-9e4f-ad5ce5a11e8d',
      subjectName: 'Energy & Environment',
      imagePath: null,
      noOfVideos: 431,
      totalVideoHours: 100,
      noOfUnits: 19,
      noOfTrialVideos: 0,
      comingSoon: false,
      updatesAvailable: false,
      subjectSubscriptionList: [],
      tags: [],
      createdAt: {
        year: 2020,
        monthValue: 6,
        month: 'JUNE',
        dayOfMonth: 9,
        dayOfYear: 161,
        dayOfWeek: 'TUESDAY',
        hour: 19,
        minute: 50,
        second: 3,
        nano: 50000000,
        chronology: {
          calendarType: 'iso8601',
          id: 'ISO',
        },
      },
      updatedAt: {
        year: 2020,
        monthValue: 6,
        month: 'JUNE',
        dayOfMonth: 9,
        dayOfYear: 161,
        dayOfWeek: 'TUESDAY',
        hour: 19,
        minute: 50,
        second: 3,
        nano: 50000000,
        chronology: {
          calendarType: 'iso8601',
          id: 'ISO',
        },
      },
    },
  ],
  publishingInfo: null,
  addOns: [],
  testimonials: [],
  updatesAvailable: false,
  version: 0,
  featured: true,
  tags: ['string'],
  createdAt: {
    year: 2020,
    monthValue: 6,
    month: 'JUNE',
    dayOfMonth: 9,
    dayOfYear: 161,
    dayOfWeek: 'TUESDAY',
    hour: 19,
    minute: 50,
    second: 3,
    nano: 50000000,
    chronology: {
      calendarType: 'iso8601',
      id: 'ISO',
    },
  },
  updatedAt: {
    year: 2020,
    monthValue: 6,
    month: 'JUNE',
    dayOfMonth: 9,
    dayOfYear: 161,
    dayOfWeek: 'TUESDAY',
    hour: 19,
    minute: 50,
    second: 3,
    nano: 50000000,
    chronology: {
      calendarType: 'iso8601',
      id: 'ISO',
    },
  },
  requestType: null,
  totalNoOfVideosInCatalogue: 433,
  totalNoOfVideoHours: 100,
});
